const generateChatResponse = async (messages, promptType) => {
  try {
    const response = await APIClient.put(
      "/ai_enhance_text",
      {
        max_tokens: 1500,
        temperature: 0,
        top_p: 0.9,
        user_message: messages,
        system_prompt:
          promptType === 1
            ? "As an assistant, your task is solely to refine and improve the text provided by the user..."
            : "As an assistant, give me short definition or description of the text...",
      },
      (response) => response.enhanceText,
    )

    return response
  } catch (error) {
    console.error("Error generating chat response:", error.message)
    throw error
  }
}

export default generateChatResponse
